import Browser from '../../assets/icons/browser.svg'
import CashRegister from '../../assets/icons/cash-register.svg'
import DameJidlo from '../../assets/icons/dame-jidlo.svg'
import PhoneCall from '../../assets/icons/phone-call.svg'
import QRCode from '../../assets/icons/qr-code.svg'
import Wolt from '../../assets/icons/wolt.svg'

export enum OrderStatesEnum {
    NEW = 'new',
    QUEUED_FOR_PROCESSING = 'queued-for-processing',
    IN_PROCESS = 'in-process',
    COOKED = 'cooked',
    ASSEMBLED = 'assembled',
    DELIVERING = 'delivering',
    FINISHED = 'finished',
    ANNULLED = 'annulled',
    CANCELLED = 'cancelled',
    REFUNDED = 'refunded',
    UNDELIVERED = 'undelivered',
}

export type IStationState =
    | OrderStatesEnum.NEW
    | OrderStatesEnum.IN_PROCESS
    | OrderStatesEnum.COOKED

export enum OrderSourceEnum {
    GASTRO_WEB = 'gastro_web',
    GASTRO_QR_CODE = 'gastro_qr_code',
    GASTRO_TERMINAL_APP = 'gastro_terminal_app',
    GASTRO_POS = 'gastro_pos',
    DAMEJIDLO_API = 'damejidlo_api',
    WOLT_API = 'wolt_api',
}

export const sourceIcons = {
    [OrderSourceEnum.GASTRO_WEB]: Browser,
    [OrderSourceEnum.GASTRO_QR_CODE]: QRCode,
    [OrderSourceEnum.GASTRO_TERMINAL_APP]: PhoneCall,
    [OrderSourceEnum.GASTRO_POS]: CashRegister,
    [OrderSourceEnum.DAMEJIDLO_API]: DameJidlo,
    [OrderSourceEnum.WOLT_API]: Wolt,
}
